const ListStyles = {
    gridLayout: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 w-full gap-1"
}

export default ListStyles